export default "__VITE_ASSET__7L4Tef3v__"